// extracted by mini-css-extract-plugin
export default {"link":"Footer_link__3Ie8d","icon":"Footer_icon__Zscac"};